import { useCallback, useState } from 'react';

const useModal = (initialState = false) => {
  const [isOpen, setIsOpen] = useState(initialState);

  const openModal = useCallback((value) => {
    if (value && value.nativeEvent instanceof Event) {
      setIsOpen(true);
      return;
    }
    if (value) {
      setIsOpen(value);
      return;
    }
    setIsOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setIsOpen(false);
  }, []);

  return { isOpen, openModal, closeModal };
};

export default useModal;
